export default __webpack_public_path__ + "static/media/iconInboundForm.1b1d2bbf.svg";